import React from 'react'
import { styled, useMediaQuery, useTheme } from '@mui/material'
import MuiAppBar from '@mui/material/AppBar'
import Nav from './Nav'
import { Size } from '../../util/types'
import AccountSelector from '../../features/azure-b2c/components/AccountSelector'
import { DRAWER_DIMENSIONS, PAGE_PADDING_SIDE } from '../../util/consts'
import headerBackground from '../../assets/images/header-bg.png'
import { shouldForwardProp } from '../../util/helpers'
import { CartHeader } from '../../features/cart/components/CartHeader'

interface AppbarProps extends Record<string, unknown> {
  height: Size
}

const AppBar = styled(MuiAppBar, {
  shouldForwardProp: (prop) => shouldForwardProp<AppbarProps>(['height'], prop),
})<AppbarProps>(({ theme, height }) => ({
  transition: theme.transitions.create(['margin', 'width'], {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  backgroundImage: `url(${headerBackground})`,
  marginLeft: 0,
  width: '100%',
  height: `calc(${height.lg}px + var(--safe-area-statusbarHeight))`,
  display: 'flex',
  alignItems: 'flex-end',
  flexDirection: 'row-reverse',

  padding: `0px ${PAGE_PADDING_SIDE.lg}px`,

  [theme.breakpoints.down('lg')]: {
    padding: `0px ${PAGE_PADDING_SIDE.md}px`,
  },
  [theme.breakpoints.between('md', 'lg')]: {
    height: `calc(${height.md}px + var(--safe-area-statusbarHeight))`,
  },
}))

const HeaderContentContainer = styled('div')(({ theme }) => ({
  float: 'right',
  display: 'inline-flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  width: '100%',
  marginBottom: '24px',
  [theme.breakpoints.up('md')]: {
    paddingLeft: `min(21vw, ${DRAWER_DIMENSIONS.width.lg + 8}px)`,
  },
}))

type HeaderProps = {
  appbarHeight: Size
}

const Header = (props: HeaderProps) => {
  const { appbarHeight } = props
  const theme = useTheme()
  const isMedium = useMediaQuery(theme.breakpoints.down('md'))

  if (isMedium) {
    return <Nav />
  }
  return (
    <>
      <AppBar height={appbarHeight} position='sticky'>
        {!isMedium && (
          <HeaderContentContainer>
            <CartHeader />
            <AccountSelector
              color={theme.colors.primary25}
              alignment={'right'}
              labelStyle={{ margin: 0 }}
            />
          </HeaderContentContainer>
        )}
      </AppBar>
      <Nav />
    </>
  )
}

export default Header
